import React from 'react';
import ServicesTypeOne from "../../components/services/services-one/ServicesTypeOne";
import servicesData from "../../components/services/services-one/ServicesOneData.json";
import Layout from "../../common/Layout";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import {Helmet} from "react-helmet";


const ServicesOne = () => {
    return (
        <>
            <Helmet>
                <title>Our Services || Iron Wall X - Professional Security Solutions Turkey</title>
                <meta name="description" content="Explore Iron Wall X's comprehensive security services: corporate security, CCTV surveillance, residential protection, event security, access control systems, and security consulting across Turkey." />
                <meta name="keywords" content="security services Turkey, CCTV installation Turkey, corporate security solutions, residential security, event security Turkey, access control systems, security consulting Turkey, Iron Wall X services" />
            </Helmet>
            <Layout>
                <Breadcrumb
                    pageTitle="Our Services"
                    rootPath="/"
                    parentPath="Home"
                    currentPath="Services"
                />
                {/* Service Start */}
                <div className="service-sec pt-100 pb-100">
                    <div className="container">
                        <div className="row">
                            {
                                servicesData.map((item) => (
                                    <ServicesTypeOne
                                        key={item.id}
                                        data={item}
                                    />
                                ) )
                            }
                        </div>
                    </div>
                </div>
                {/* Service End */}
            </Layout>
        </>
    );
};

export default ServicesOne;